import { useEffect } from 'react';

const sameTab=(anchor,href)=>{
 anchor.target='_self';anchor.rel='';
 anchor.addEventListener('click',event=>{
  if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  event.preventDefault();event.stopPropagation();window.location.assign(href);
 });
};

export default function CoreProductConversionNavBridge(){
 useEffect(()=>{
  const install=()=>{
   document.querySelectorAll('a[href="/depo/stok-hareketleri"]').forEach(movementLink=>{
    const parent=movementLink.parentElement;if(!parent||parent.querySelector('a[data-core-conversion-link="1"]'))return;
    const link=document.createElement('a');link.href='/depo/cekirdek-donusturme';link.dataset.coreConversionLink='1';link.className=movementLink.className;link.innerHTML=movementLink.innerHTML;
    const label=[...link.querySelectorAll('span')].find(x=>x.textContent?.includes('Stok Hareketleri'));
    if(label)label.textContent='Çekirdek Ürün Dönüştür';else link.textContent='Çekirdek Ürün Dönüştür';
    sameTab(link,'/depo/cekirdek-donusturme');
    movementLink.insertAdjacentElement('afterend',link);
   });
  };
  install();const observer=new MutationObserver(install);observer.observe(document.body,{childList:true,subtree:true});return()=>observer.disconnect();
 },[]);
 return null;
}
